/*
 *******************************************************************************
 * 
 *  Filename:   ./config/routesSystemNavigation.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Routes for System Navigation Components
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, September 15, 2018 - 9:58 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      09/15/2018  NJN     File Created
 *      09/17/2018  NJN     Added Components and Component Pages
 *      09/18/2018  NJN     Add Navs
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Loading...</div>;
}

export const NavGroups = Loadable({
    loader: () => import('../containers/NavGroups/NavGroupListContainer'),
    loading: Loading,
});

export const NavGroupEdit = Loadable({
    loader: () => import('../containers/NavGroups/NavGroupEditContainer'),
    loading: Loading,
});

export const Navs = Loadable({
    loader: () => import('../containers/Navs/NavListContainer'),
    loading: Loading,
});

export const NavEdit = Loadable({
    loader: () => import('../containers/Navs/NavEditContainer'),
    loading: Loading,
});

export const NavTypes = Loadable({
    loader: () => import('../containers/NavTypes/NavTypeListContainer'),
    loading: Loading,
});

export const NavTypeEdit = Loadable({
    loader: () => import('../containers/NavTypes/NavTypeEditContainer'),
    loading: Loading,
});

export const ComponentGroups = Loadable({
    loader: () => import('../containers/ComponentGroups/ComponentGroupListContainer'),
    loading: Loading,
});

export const ComponentGroupEdit = Loadable({
    loader: () => import('../containers/ComponentGroups/ComponentGroupEditContainer'),
    loading: Loading,
});

export const Components = Loadable({
    loader: () => import('../containers/Components/ComponentListContainer'),
    loading: Loading,
});

export const ComponentEdit = Loadable({
    loader: () => import('../containers/Components/ComponentEditContainer'),
    loading: Loading,
});

export const ComponentPages = Loadable({
    loader: () => import('../containers/ComponentPages/ComponentPageListContainer'),
    loading: Loading,
});

export const ComponentPageEdit = Loadable({
    loader: () => import('../containers/ComponentPages/ComponentPageEditContainer'),
    loading: Loading,
});


// WEBPACK FOOTER //
// ./src/config/routesSystemNavigation.js